.banner {
  padding: 80px 24px 100px;
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  max-width: 1080px;
  margin: 0 auto;
  padding: 40px 48px;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-xl);
  text-align: left;
  background:
    radial-gradient(
      ellipse at 50% 0%,
      rgba(124, 58, 237, 0.2),
      transparent 60%
    ),
    var(--color-bg-card);
  box-shadow: var(--shadow-glow);
}

.title {
  margin: 0;
  font-size: clamp(22px, 2.4vw, 30px);
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
}

.actions {
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 12px;
}

@media (max-width: 1040px) and (min-width: 901px) {
  .inner {
    gap: 20px;
    padding: 36px 28px;
  }

  .title {
    font-size: clamp(18px, 2.1vw, 24px);
  }
}

@media (max-width: 900px) {
  .inner {
    flex-direction: column;
    max-width: 720px;
    padding: 36px 24px;
    text-align: center;
  }

  .title {
    white-space: normal;
  }

  .actions {
    flex-wrap: wrap;
    justify-content: center;
  }
}
